import { isMogrtFileName, PREMIERE_GRAPHICS_TEMPLATES_LOCATION } from '~/utils/premiereImportableExtensions';

export const getSingleImportSuccessToastMessage = (fileName: string | undefined): string => {
  if (!fileName) {
    return 'Imported 1 asset';
  }

  return isMogrtFileName(fileName) ? `Installed to ${PREMIERE_GRAPHICS_TEMPLATES_LOCATION}` : 'Imported 1 asset';
};
